import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoBolt16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M13.1987 5.83334H9.16688C8.98281 5.83334 8.83354 5.6841 8.83354 5.50001V1.57047C8.83354 1.24337 8.41148 1.11195 8.22581 1.38123L2.52728 9.64407C2.37478 9.86521 2.53306 10.1667 2.80168 10.1667H6.83354C7.01761 10.1667 7.16688 10.3159 7.16688 10.5V14.4295C7.16688 14.7567 7.58888 14.8881 7.77461 14.6188L13.4731 6.35592C13.6257 6.13479 13.4673 5.83334 13.1987 5.83334Z" stroke={iconColor} strokeWidth={1.5} strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoBolt16;